import { Lock } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ImageGif from '../../../assets/gif/pikachu.gif';
import ReactAudioPlayer from 'react-audio-player';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../configuration';
import RequestUnlockDonate from '../../../components/request-unlock-donate/request-unlock-donate.component';
import EligibilityChecklist from '../../../components/eligibility/eligibility-checklist';
import { fetchProfile } from '../../../redux/features/auth/slice';
import SectionTabs, { SectionTabItem } from '../../../components/section-tabs/section-tabs';
import { resolveActiveTab } from '../../../utils/section-tabs';
import {
  getUserDonateSettings,
  getUserDonateSettingsByUserID,
  updateUserDonateSettings,
} from '../../../api';
import { ChromePicker } from 'react-color';
import { toastSelector } from '../../../store/store-common-message/selector';
import toast from 'react-hot-toast';
import { InputWarning } from '../../../components/inputwarning/input-warning.component';
import { CustomDropdown } from './custom-dropdown';
import AlertStyleSetting from './alert-style-setting';
import AlertVolumeSetting from './alert-volume-setting';
import VoiceMessageSetting from './voice-message-setting';
import DonateAlertTiersSetting from './donate-alert-tiers-setting';
import DonateGoalSetting from './donate-goal-setting';
import SpinWheelSetting from './spin-wheel-setting';
import DonatePollSetting from './donate-poll-setting';
import DonateChallengeSetting from './donate-challenge-setting';
import LiveEffectSetting from './live-effect-setting';
import MembershipSetting from './membership-setting';
import MusicRequestSetting from './music-request-setting';
import AiQuestionSettingBlock from './ai-question-setting';
import SubathonSetting from './subathon-setting';
import TopDonateSetting from './top-donate-setting';
import DonateKindsBoard from './donate-kinds-board';

// 6 tab gọn khu Cài đặt Donate, tránh cuộn dài mới thấy hết tính năng. Param `muc` trên URL
// (không dùng `tab` — trang khác trong app đã dùng `?tab=` cho các tab lớn hơn).
const MUC_TABS: SectionTabItem[] = [
  { key: 'chung', label: 'Chung' },
  { key: 'thong-bao', label: 'Thông báo' },
  { key: 'muc-tieu', label: 'Mục tiêu, Subathon & Top' },
  { key: 'tuong-tac', label: 'Tương tác' },
  { key: 'hoi-vien', label: 'Hội viên' },
  { key: 'nhac-ai', label: 'Nhạc & Hỏi AI' },
];
const MUC_KEYS = MUC_TABS.map((t) => t.key);

const DonateSetting = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeMuc =
    resolveActiveTab(MUC_KEYS, searchParams.get('muc'), 'chung') || 'chung';
  const handleMucChange = (key: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('muc', key);
    setSearchParams(next, { replace: true });
  };

  const { host, protocol } = window.location;
  const profile = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const dispatch = useDispatch<AppDispatch>();
  const [tab, setTab] = React.useState('tab1');
  const [selectedSound, setSelectedSound] = React.useState('sound_1.mp3');
  const [selectedGif, setSelectedGif] = React.useState('img_1.gif');
  const [isSoundGoogle, setIsSoundGoogle] = React.useState(true);
  const [colorText, setColorText] = React.useState('#000000');
  const [animationText, setAnimationText] = React.useState('bounceIn');
  const [animationIn, setAnimationIn] = React.useState('bounceIn');
  const [animationOut, setAnimationOut] = React.useState('bounceOut');
  const [showColorPicker, setShowColorPicker] = React.useState(false);
  const [savingDonate, setSavingDonate] = React.useState(false); // QA S-27
  // Tầng ẩn phía STREAMER (tầng còn lại: người donate tự tick ẩn danh khi donate).
  const [hideDonationLog, setHideDonationLog] = React.useState(false);

  const openPopupWindow = () => {
    const url = `${protocol}//${host}/donate-screen/${profile?.userId}?isTest=true&sound=${selectedSound}&image=${selectedGif}&colorText=${colorText}&animationText=${animationText}&animationIn=${animationIn}&animationOut=${animationOut}&isSoundGoogle=${isSoundGoogle}`;
    const windowFeatures = 'width=600,height=400,top=100,left=100';
    window.open(url, 'popup', windowFeatures);
  };

  const soundFiles = [
    'sound_1.mp3',
    'sound_2.mp3',
    'sound_3.mp3',
    'sound_4.mp3',
    'sound_5.mp3',
    'sound_6.mp3',
    'sound_7.mp3',
    'sound_8.mp3',
    'sound_9.mp3',
    'sound_10.mp3',
    'sound_11.mp3',
    'sound_12.mp3',
    'sound_13.mp3',
    'sound_14.mp3',
    'sound_15.mp3',
  ];

  const gifFiles = [
    'img_1.gif',
    'img_2.gif',
    'img_3.gif',
    'img_4.gif',
    'img_5.gif',
    'img_6.gif',
    'img_7.gif',
    'img_8.gif',
    'img_9.gif',
    'img_10.gif',
    'img_11.gif',
    'img_12.gif',
    'img13.gif',
  ];

  const getUserSettingDonate = (userId) => {
    getUserDonateSettingsByUserID(userId).then((res) => {
      if (res) {
        setSelectedSound(res.sound);
        setSelectedGif(res.image);
        setIsSoundGoogle(res.isSoundGoogle);
        setColorText(res.colorText);
        setAnimationText(res.animationText);
        setAnimationIn(res.animationIn);
        setAnimationOut(res.animationOut);
        setHideDonationLog(!!res.hideDonationLog);
      }
    });
  };

  const handleSaveSettings = () => {
    if (savingDonate) return; // QA S-27: chống double-submit
    setSavingDonate(true);
    updateUserDonateSettings({
      isSoundGoogle,
      colorText,
      animationText,
      animationIn,
      animationOut,
      sound: selectedSound,
      image: selectedGif,
      hideDonationLog,
    })
      .then(() => {
        toast.success('Cập nhật thành công');
      })
      .catch((error) => {
        toast.error('Cập nhật thất bại');
      })
      .finally(() => setSavingDonate(false)); // QA S-27
  };

  useEffect(() => {
    if (profile?.userId) getUserSettingDonate(profile.userId);
  }, [profile?.userId]);

  if (profile?.canReceiveDonation) {
    return (
      <div>
        <SectionTabs tabs={MUC_TABS} active={activeMuc} onChange={handleMucChange} />

        {activeMuc === 'chung' && (
          <>
            {/* Một chỗ thấy hết kiểu donate nào đang bật, bấm là sang đúng tab có công tắc. */}
            <DonateKindsBoard
              userId={profile?.userId}
              onGo={(muc) => {
                handleMucChange(muc);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            />
            <div className="border rounded-xl border-[#DEE0E6] dark:border-slate-700 flex justify-center items-center flex-col">
              <p className="p-3 h-[51px] flex items-center w-full text-[#18191E] font-semibold  text-[22px] leading-[27px]">
                Livestream donate
              </p>
              <div className="w-full flex flex-col gap-2 bg-[#f6f7f8] dark:bg-dark2 p-3">
                <div className="flex flex-col gap-1 flex-start w-full">
                  <h2 className="text-sm">Link donate của bạn</h2>
                  <div className="text-base flex items-center text-start px-3 border h-12 border-[#C8CCD8] dark:border-slate-600 bg-[#EBECF2] dark:bg-slate-700 text-[#A1A5B6] dark:text-slate-400 rounded-lg">
                    <span className="w-full truncate">
                      {`${protocol}//${host}/user/${profile?.username}`}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col gap-1 flex-start w-full">
                  <h2 className="text-sm">
                    Link hiển thị donate ( Add Webpage URL trong phần mềm Stream )
                  </h2>
                  <div className="text-base flex items-center text-start px-3 border h-12 border-[#C8CCD8] dark:border-slate-600 bg-[#EBECF2] dark:bg-slate-700 text-[#A1A5B6] dark:text-slate-400 rounded-lg">
                    <span className="w-full truncate">
                      {`${protocol}//${host}/donate-screen/${profile?.userId}`}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col justify-center items-center gap-2">
                  <img
                    alt="gif"
                    src={`/gif/${selectedGif}`}
                    className="w-64 h-64 object-contain"
                  />
                  <ReactAudioPlayer
                    className="h-6 active"
                    src={`/sound/${selectedSound}`}
                    controls
                  />
                </div>
              </div>
              <div className="px-6 pb-2">
                <label className="flex items-start gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={!hideDonationLog}
                    onChange={(e) => setHideDonationLog(!e.target.checked)}
                    className="mt-[3px] h-4 w-4 shrink-0 rounded border-[#C8CCD8] accent-blue-600"
                  />
                  <span className="text-sm text-gray-700 dark:text-gray-300">
                    Hiện lịch sử donate trên trang cá nhân
                    <span className="block text-xs text-gray-500 dark:text-gray-400">
                      Người xem thấy ai đã donate, lời nhắn và số Ca — giúp khuyến khích ủng hộ.
                      Tắt đi nếu bạn muốn giữ riêng tư. Người donate chọn ẩn danh luôn được giấu
                      tên, dù bật hay tắt.
                    </span>
                  </span>
                </label>
              </div>
              <div className=" flex justify-between w-full items-center p-6 gap-4">
                <button
                  onClick={openPopupWindow}
                  className="button bg-[#39539E] text-white px-4 py-2 rounded-lg text-base"
                >
                  Test
                </button>
                <button
                  onClick={handleSaveSettings}
                  disabled={savingDonate}
                  className="button bg-blue-500 text-white px-4 py-2 rounded-lg text-base disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  Lưu thay đổi
                </button>
              </div>
            </div>

            <div className=" border rounded-xl border-[#DEE0E6] dark:border-slate-700 mt-[10px]">
              <div className="text-sm p-3 font-medium text-center text-gray-500 dark:text-gray-400 dark:border-gray-700">
                <ul className="flex flex-wrap border-b gap-1">
                  <li>
                    <button
                      onClick={() => setTab('tab1')}
                      className={`inline-block px-3 py-4 text-[16px] leading-4 border-b-2 rounded-t-lg ${
                        tab === 'tab1'
                          ? 'text-[#234093] border-[#234093]'
                          : 'text-gray-600 hover:border-gray-300 border-transparent'
                      } dark:text-gray-300 dark:border-gray-300`}
                    >
                      Hình ảnh
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => setTab('tab2')}
                      className={`inline-block px-3 py-4 text-[16px] leading-4 border-b-2 rounded-t-lg ${
                        tab === 'tab2'
                          ? 'text-[#234093] border-[#234093]'
                          : 'text-gray-600 hover:border-gray-300 border-transparent'
                      } dark:text-blue-500 dark:border-blue-500`}
                      aria-current="page"
                    >
                      Âm thanh
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => setTab('tab3')}
                      className={`inline-block px-3 py-4 text-[16px] leading-4 border-b-2 rounded-t-lg ${
                        tab === 'tab3'
                          ? 'text-[#234093] border-[#234093]'
                          : 'text-gray-600 hover:border-gray-300 border-transparent'
                      } dark:text-gray-300 dark:border-gray-300`}
                    >
                      Cài đặt khác
                    </button>
                  </li>
                </ul>
              </div>
              {tab === 'tab1' && (
                <div className="bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-full">
                  <h3 className="text-lg bg-[#EBECF2] dark:bg-slate-700 font-bold text-gray-900 dark:text-white mb-4 h-12 flex items-center px-5">
                    Hình ảnh thông báo
                  </h3>
                  <div className="px-4 py-4">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                      {gifFiles.map((gif, index) => (
                        <div
                          key={gif}
                          className={`p-4 border border-[#E5E7EB] dark:border-slate-700 rounded-lg cursor-pointer ${
                            selectedGif === gif &&
                            'bg-[linear-gradient(to_top,#DBE8FB,#F3F7FB)] border-transparent'
                          }`}
                          onClick={() => setSelectedGif(gif)}
                        >
                          {/* <div className="flex items-center justify-between mb-2">
                            <span className="text-sm font-medium text-gray-900">
                              Hình ảnh {index + 1}
                            </span>
                            {selectedGif === gif && (
                              <div className="w-2 h-2 bg-blue-500 rounded-full" />
                            )}
                          </div> */}
                          <div className="aspect-square overflow-hidden rounded-lg">
                            <img
                              src={`/gif/${gif}`}
                              alt={`GIF ${index + 1}`}
                              className="w-full h-full object-contain"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {tab === 'tab2' && (
                <div className=" bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-full">
                  <h3 className="text-lg bg-[#EBECF2] dark:bg-slate-700 font-bold text-gray-900 dark:text-white mb-4 h-12 flex items-center px-5">
                    Âm thanh thông báo
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 p-4 pt-0">
                    {soundFiles.map((sound, index) => (
                      <div
                        key={sound}
                        className={`p-3 border rounded-xl cursor-pointer ${
                          selectedSound === sound &&
                          'bg-[linear-gradient(to_top,#DBE8FB,#F3F7FB)] border-transparent'
                        }`}
                        onClick={() => setSelectedSound(sound)}
                      >
                        {/* <div className="flex items-center justify-between mb-2">
                            <span className="text-sm font-medium text-gray-900">
                              Âm thanh {index + 1}
                            </span>
                            {selectedSound === sound && (
                              <div className="w-2 h-2 bg-blue-500 rounded-full" />
                            )}
                          </div> */}
                        <ReactAudioPlayer
                          src={`/sound/${sound}`}
                          controls
                          className={`w-full ${
                            selectedSound === sound && 'active'
                          }`}
                          style={{ height: '24px' }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {tab === 'tab3' && (
                <div className="p-6 flex flex-col gap-6 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-full">
                  <CustomDropdown
                    label="Giọng chị google"
                    value={isSoundGoogle ? 'true' : 'false'}
                    options={[
                      { label: 'Bật', value: 'true' },
                      { label: 'Tắt', value: 'false' },
                    ]}
                    onChange={(val) => setIsSoundGoogle(val === 'true')}
                  />
                  <div className="flex flex-col gap-1">
                    <label className="text-sm text-[#070708] flex items-center">
                      Màu chữ&nbsp;
                      <InputWarning />
                    </label>
                    <div className="relative">
                      <div
                        className="w-full h-10 rounded-lg border border-gray-300 cursor-pointer flex items-center px-3"
                        onClick={() => setShowColorPicker(!showColorPicker)}
                        style={{ backgroundColor: `#${colorText}` }}
                      >
                        <span
                          style={{
                            color: colorText === '#FFFFFF' ? '#000000' : '#FFFFFF',
                          }}
                        >
                          {colorText}
                        </span>
                      </div>
                      {showColorPicker && (
                        <div className="absolute z-10 mt-2">
                          <div
                            className="fixed inset-0"
                            onClick={() => setShowColorPicker(false)}
                          />
                          <ChromePicker
                            color={colorText}
                            onChange={(color) =>
                              setColorText(color.hex.replace('#', ''))
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <CustomDropdown
                    label="Hiệu ứng chữ"
                    value={animationText}
                    options={[
                      { label: 'BounceIn', value: 'bounceIn' },
                      { label: 'FadeIn', value: 'fadeIn' },
                      { label: 'SlideIn', value: 'slideIn' },
                    ]}
                    onChange={setAnimationText}
                  />
                  <CustomDropdown
                    label=" Hiệu ứng xuất hiện"
                    value={animationIn}
                    options={[
                      { label: 'BounceIn', value: 'bounceIn' },
                      { label: 'FadeIn', value: 'fadeIn' },
                      { label: 'SlideIn', value: 'slideIn' },
                    ]}
                    onChange={setAnimationIn}
                  />
                  <CustomDropdown
                    label="Hiệu ứng biến mất"
                    value={animationOut}
                    options={[
                      { label: 'BounceIn', value: 'bounceIn' },
                      { label: 'FadeIn', value: 'fadeIn' },
                      { label: 'SlideIn', value: 'slideIn' },
                    ]}
                    onChange={setAnimationOut}
                  />
                </div>
              )}
            </div>
          </>
        )}

        {activeMuc === 'thong-bao' && (
          <>
            {/* Âm lượng trên OBS: tiếng thông báo, giọng đọc và ghi âm lời nhắn (streamer vừa chơi game vừa stream). */}
            <AlertVolumeSetting userId={profile?.userId} />

            {/* Giao diện thông báo: kiểu khung, vị trí, cỡ chữ, hiệu ứng dùng chung cho mọi thông báo. */}
            <AlertStyleSetting userId={profile?.userId} />

            {/* Hiệu ứng theo mốc donate: mỗi mức tiền một hiệu ứng riêng trên OBS. */}
            <DonateAlertTiersSetting userId={profile?.userId} />

            {/* Lời nhắn giọng nói: bật/tắt nhận kèm ghi âm khi donate + mức Ca tối thiểu. */}
            <VoiceMessageSetting userId={profile?.userId} />
          </>
        )}

        {activeMuc === 'muc-tieu' && (
          <>
            {/* Mục tiêu donate: đặt mục tiêu + link overlay chèn lên phiên live. */}
            <DonateGoalSetting userId={profile?.userId} />

            {/* Đếm ngược subathon: thời lượng ban đầu + tỉ lệ Ca->phút, donate cộng thêm giờ. */}
            <SubathonSetting userId={profile?.userId} />

            {/* Bảng xếp hạng donate chèn lên phiên live (tuỳ chọn nằm trên link, không lưu). */}
            <TopDonateSetting userId={profile?.userId} />
          </>
        )}

        {activeMuc === 'tuong-tac' && (
          <>
            {/* Vòng quay nhiệm vụ: người xem trả Ca để quay, streamer làm nhiệm vụ trúng. */}
            <SpinWheelSetting userId={profile?.userId} />

            {/* Bình chọn bằng donate: người xem donate cho phương án, hết giờ nhiều Ca nhất thắng. */}
            <DonatePollSetting userId={profile?.userId} />

            {/* Thử thách donate: đua top hoặc về đích, người thắng nhận phần thưởng do streamer tự hứa. */}
            <DonateChallengeSetting userId={profile?.userId} />
            {/* Hiệu ứng tương tác: người xem trả Ca bắn trò lên màn hình live, thầu khung tên. */}
            <LiveEffectSetting userId={profile?.userId} />
          </>
        )}

        {activeMuc === 'hoi-vien' && (
          <MembershipSetting userId={profile?.userId} />
        )}

        {activeMuc === 'nhac-ai' && (
          <>
            {/* Phát nhạc theo yêu cầu: người xem trả Ca kèm link YouTube để yêu cầu phát trên live. */}
            <MusicRequestSetting userId={profile?.userId} />

            {/* Hỏi đáp AI trên live: người xem trả Ca gửi câu hỏi, AI viết câu trả lời, streamer duyệt rồi phát. */}
            <AiQuestionSettingBlock userId={profile?.userId} />
          </>
        )}
      </div>
    );
  }

  // Chưa mở nhận donate: hiện danh sách điều kiện máy chủ tự kiểm, đạt nhóm bắt buộc mới gửi được yêu cầu.
  return (
    <div className="ui-card mt-4 flex flex-col gap-4 rounded-xl p-4">
      <div className="flex flex-col gap-1">
        <h2 className="ui-heading text-lg font-semibold">Mở nhận donate</h2>
        <p className="ui-muted text-sm">
          Bạn chưa mở nhận donate. Khi đạt các điều kiện bắt buộc dưới đây, bạn gửi yêu cầu để
          Cab xem hồ sơ.
        </p>
      </div>
      <EligibilityChecklist
        kind="donate"
        renderSubmit={({ enabled, label, reload }) => (
          <RequestUnlockDonate
            label={label}
            disabled={!enabled}
            onSubmitted={() => {
              reload();
              dispatch(fetchProfile());
            }}
          />
        )}
      />
    </div>
  );
};

export default DonateSetting;
